// styleguide/TypographySampleCard.tsx
import { Paper, Box, Typography, IconButton, Tooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { ValidAny } from "@/types";
import { useAppTheme } from "@/hooks/useAppTheme";

interface TypographySampleCardProps {
  sample: {
    label: string;
    variant: ValidAny;
    description: string;
    example: string;
  };
  onCopy: (text: string) => void;
}

export const TypographySampleCard = ({ sample, onCopy }: TypographySampleCardProps) => {
  const { theme, isDarkMode } = useAppTheme();

  return (
    <Paper
      elevation={1}
      sx={{
        mb: 4,
        p: 3,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 1,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant={sample.variant}>{sample.label}</Typography>
        <Tooltip title="Copy JSX snippet">
          <IconButton onClick={() => onCopy(sample.example)} size="small">
            <ContentCopy fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Typography variant="body2" color="text.secondary">
        MUI Variant: <strong>{sample.variant}</strong> — {sample.description}
      </Typography>
      <Paper
        sx={{
          backgroundColor: isDarkMode ? "#1e1e1e" : "#f5f5f5",
          p: 2,
          mt: 1,
          fontFamily: "monospace",
          fontSize: 14,
          borderRadius: 1,
        }}
      >
        {sample.example}
      </Paper>
    </Paper>
  );
};
